export type RuntimeConfig = {
  apiUrl: string
  oidcAuthority: string
  oidcClientId: string
  oidcMetadataUrl: string
}

let runtimeConfig: RuntimeConfig | null = null

export function getRuntimeConfig(): RuntimeConfig | null {
  return runtimeConfig
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (runtimeConfig) return runtimeConfig

  const res = await fetch('/runtime-config', {
    headers: {
      Accept: 'application/json',
    },
  })

  if (!res.ok) {
    throw new Error(`Failed to load runtime config: ${res.status}`)
  }

  const cfg = (await res.json()) as RuntimeConfig
  runtimeConfig = cfg
  return cfg
}
